import React, { useEffect, useState } from "react";
import { View } from "react-native";
import { modifiersToDatesInMonth } from "@clearabee/ui-library-base";
import Calendar from "react-native-calendars/src/calendar";
import dayjs from "dayjs";
import { calendarStyles, calendarTheme, selectableDateStyles, } from "./InputDate.styles";
import { theme } from "../../../../theme";
import { Icon } from "../../../Icon/Icon";
import { formatDate, getDatesInMonth } from "./helper";
const today = formatDate();
export const InputDate = ({ onChange, initialValue, value, disabledDays: propDisabledDays, dateFormat, styles: userStyles, todayMarker = false, firstDay, month, color = "brand", }) => {
    const [date, setDate] = useState(typeof initialValue === "string"
        ? dayjs(initialValue, dateFormat).toDate()
        : typeof value === "string"
            ? dayjs(value, dateFormat).toDate()
            : initialValue || value);
    const current = month ?? date ?? new Date();
    const monthRef = React.useRef(current);
    const [disabledDays, setDisabledDays] = useState([]);
    useEffect(() => {
        setDisabledDays(propDisabledDays
            ? modifiersToDatesInMonth(propDisabledDays, date ?? month ?? new Date()).map(formatDate)
            : []);
    }, [propDisabledDays]);
    const handleMonthChange = (date) => {
        monthRef.current = new Date(date.year, date.month - 1, 1);
        if (propDisabledDays)
            setDisabledDays(modifiersToDatesInMonth(propDisabledDays, new Date(date.year, date.month - 1, 1)).map(formatDate));
    };
    const handlePress = (dateData) => {
        const date = dayjs(dateData.dateString).toDate();
        setDate(date);
    };
    useEffect(() => {
        onChange?.(date ? dayjs(date).format(dateFormat) : "");
    }, [date]);
    const disabledMarks = disabledDays.reduce((final, date) => ({ ...final, [date]: { disabled: true } }), {});
    const isTodayDisabled = disabledDays.includes(today) || (month && dayjs(month).isAfter(today));
    const monthDays = getDatesInMonth(monthRef.current).reduce((final, date) => ({
        ...final,
        [date]: selectableDateStyles(color),
    }), {});
    return (React.createElement(View, { style: userStyles },
        React.createElement(Calendar
        // Types are wrong, created issue: https://github.com/wix/react-native-calendars/issues/1662
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        , { 
            // Types are wrong, created issue: https://github.com/wix/react-native-calendars/issues/1662
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            onMonthChange: handleMonthChange, current: current.toISOString(), day: date, firstDay: firstDay, onDayPress: handlePress, style: calendarStyles, markingType: "custom", markedDates: {
                ...monthDays,
                ...disabledMarks,
                ...(todayMarker
                    ? {
                        [today]: {
                            customStyles: {
                                container: {
                                    borderWidth: 1,
                                    borderColor: theme.colors[color].base,
                                    opacity: isTodayDisabled ? 0.5 : 1,
                                    borderRadius: theme.spacing.xsmall2,
                                },
                                text: {
                                    color: "black",
                                    fontWeight: "bold",
                                    opacity: isTodayDisabled ? 0.5 : 1,
                                },
                            },
                            disabled: isTodayDisabled,
                        },
                    }
                    : {
                        [today]: isTodayDisabled
                            ? {
                                disabled: true,
                            }
                            : selectableDateStyles(color),
                    }),
                ...(date
                    ? {
                        [formatDate(date)]: {
                            customStyles: {
                                container: {
                                    backgroundColor: theme.colors[color].base,
                                    borderRadius: theme.spacing.xsmall2,
                                },
                                text: {
                                    color: theme.colors[color === "brand" ? "light" : "dark"].base,
                                },
                            },
                        },
                    }
                    : {}),
            }, disabledDaysIndexes: [0, 6], disableAllTouchEventsForDisabledDays: true, theme: calendarTheme, renderArrow: (direction) => (React.createElement(View, { style: direction === "left" && { transform: [{ rotate: "180deg" }] } },
                React.createElement(Icon.Chevron, { color: "brand", size: "small" }))) })));
};
//# sourceMappingURL=InputDate.js.map